module.exports = __webpack_public_path__ + "img/photo-5.490a0ded.jpg";